import { LengthTool } from "@cornerstonejs/tools";

/**
 * CalibrationLineTool — a MedDream-style "Calibration line".
 *
 * It is a plain LengthTool registered under a DISTINCT tool name so it behaves
 * exactly like drawing a length line (two clicks), but the app can tell a
 * calibration draw apart from a real measurement on ANNOTATION_COMPLETED.
 *
 * The actual calibration (turn the drawn pixel length into a real-world mm
 * scale, then apply it to the image so every tool reads mm) is handled in
 * CalibrationService.applyCalibrationFromAnnotation — this class only exists so
 * the completed annotation carries metadata.toolName === "CalibrationLine".
 *
 * Why a subclass instead of reusing LengthTool with a flag: a dedicated tool
 * name lets the tool-group activate/deactivate it independently and keeps the
 * transient calibration line out of the saved measurement set (we remove it on
 * completion) without touching the real Length tool's behaviour.
 */
class CalibrationLineTool extends LengthTool {}

// Assigned as a plain static property (not a `static {}` block) so it compiles
// under this project's Babel config, which doesn't enable static class blocks.
CalibrationLineTool.toolName = "CalibrationLine";

export default CalibrationLineTool;
